// extracted by mini-css-extract-plugin
module.exports = {"popup":"IncomeConfirmationModal_popup__9rYW7","header":"IncomeConfirmationModal_header__mSAih","cards":"IncomeConfirmationModal_cards__7L_5U"};